import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-0 font-size-18">{props.breadcrumbTitle ? props.breadcrumbTitle : props.breadcrumbItem}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <div>{props.title}</div>
              </BreadcrumbItem>
              {props.parentsBreadcrumb && props.parentsBreadcrumb.map((item, key) =>
                <BreadcrumbItem key={key}>
                  <Link to={item.link}>{item.title}</Link>
                </BreadcrumbItem>
              )}
              <BreadcrumbItem active>
                <Link to="#">{props.breadcrumbItem}</Link>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  breadcrumbTitle: PropTypes.string || null,
  title: PropTypes.string,
  parentsBreadcrumb: PropTypes.any
}

export default Breadcrumb
